import { render, staticRenderFns } from "./start_exam.vue?vue&type=template&id=8257a2c2&"
import script from "./start_exam.vue?vue&type=script&lang=js&"
export * from "./start_exam.vue?vue&type=script&lang=js&"
import style0 from "./start_exam.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports